import React from 'react';
import { useSelector } from "react-redux";
import languages from "languages/languages";
import MenuFeaturesSkeleton from "./skeleton/MenuFeaturesSkeleton";
import placeholder1000x625 from "assets/placeholder/1000x625.png";
import styles from "./MenuFeatures.module.css";

function MenuFeatures(props) {
    const {loading, menuFeatures} = props;
    const langState = useSelector((state) => state.language.lang);

    if(!menuFeatures || loading) {
        return <MenuFeaturesSkeleton />;
    }
    
    return(
        <>
            <h2 className={styles.title}>{languages[langState]["Thực đơn"]}</h2>
            <div className={styles.list_items}>          
                {menuFeatures.map((menuFeature, index)=>{
                    return(
                        <div className={styles.wrapp_item} key={index}>
                            <h4 className={styles.item_title}>{menuFeature.name}</h4>
                            <div className={styles.item_image}>
                                <img src={menuFeature.image || placeholder1000x625} alt={menuFeature.name}/>
                            </div>
                        </div>
                    );
                })} 
            </div> 
        </>                   
    );
}
export default MenuFeatures;